import axios from 'axios'

import {SERVER_API_URL} from '@/constants'

const TIMEOUT = 1000000
const onRequestSuccess = (config) => {
  config.timeout = TIMEOUT
  config.url = `${SERVER_API_URL}${config.url}`

  return config
}
const setupAxiosInterceptors = (onUnauthenticated, onServerError) => {
  const onResponseError = (err) => {
    const status = err.status || err.response.status

    if (status === 403 || status === 401) {
      onUnauthenticated()
    }
    if (status >= 500) {
      onServerError()
    }
    return Promise.reject(err)
  }

  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess)
    axios.interceptors.response.use((res) => res, onResponseError)
  }
}

export {onRequestSuccess, setupAxiosInterceptors}
